/** @jsx jsx */
import {Elements} from '@stripe/react-stripe-js'
import {loadStripe} from '@stripe/stripe-js'
import DonationBox from 'components/DonationBox'
import {graphql} from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import {jsx} from 'theme-ui'
import {DonationHeaderFragment} from '../graphqlTypes'
import env from 'lib/env'
import {DonationPurpose} from './DonationBox/shared'

type Props = {
  data: DonationHeaderFragment
  project: DonationPurpose
}

const STRIPE_PUB_KEY = env.GATSBY_STRIPE_PUB_KEY

const stripePromise = loadStripe(STRIPE_PUB_KEY)

const DonationHeader: React.FC<Props> = ({data, project}) => {
  return (
    <Elements stripe={stripePromise}>
      <div
        id="white-background"
        sx={{
          backgroundColor: '#fff',
          position: 'absolute',
          top: 0,
          height: 378,
          right: 0,
          left: 0,
        }}
      ></div>
      <div
        sx={{
          width: [, , 1028],
          mx: 'auto',
          maxWidth: [, , '90%'],
        }}
      >
        <BackgroundImage
          Tag="div"
          sx={{
            padding: [, , '37px 40px'],
            minHeight: [, , 680],
            display: 'flex',
            flexDirection: 'row-reverse',
            '::before, ::after': {
              borderRadius: [, , 25],
            },
          }}
          fluid={data.heroImage.childImageSharp.fluid}
          backgroundColor="#F5F5F5"
        >
          <DonationBox project={project} />
        </BackgroundImage>
      </div>
    </Elements>
  )
}

export default DonationHeader

export const query = graphql`
  fragment DonationHeader on Query {
    heroImage: file(relativePath: {eq: "donation-bg.png"}) {
      childImageSharp {
        fluid(maxWidth: 1028) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
  }
`
